import React from 'react'
import { ConversionCampaignOffer, OfferMeta } from '../../../../types/conversions'
import LockedOffer from '../LockedOffer/LockedOffer'
import OfferMilestones from '../OfferMilestones/OfferMilestones'

const CreatorSale:React.FC<{offer: ConversionCampaignOffer, meta: OfferMeta}> = ({offer, meta}) => {
  return (
    <div>
        {
            offer.milestone_visible ? (
                <div>
                    <OfferMilestones offer={offer} meta={meta} />
                </div>
            ) : (
                <LockedOffer offer={offer} meta={meta} />
            )
        }
    </div>
  )
}

export default CreatorSale